<template>
  <div>
    <v-app class="p-4">

      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              max-width="700px"
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >

                <v-toolbar-title>ویرایش</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <div class="row mx-auto">
                <div class="col-md-6 mt-5">
                  <v-text-field min="1" max="10" outlined
                                oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
                                @keypress="allowOnlyNumbers($event)" type="number" dense
                                label="تعداد آگهی جدید" clearable
                                v-model.number="updatedData.per"
                                clear-icon="mdi-close-circle-outline"
                                prepend-inner-icon="fa fa-pencil-alt">

                  </v-text-field>
                </div>
                <div class="col-md-6 mt-5">
                  <v-text-field outlined min="1" max="10"
                                oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
                                @keypress="allowOnlyNumbers($event)" type="number" dense
                                label="تعداد آگهی من" clearable clear-icon="mdi-close-circle-outline"
                                prepend-inner-icon="fa fa-pencil-alt"
                                v-model.number="updatedData.count">

                  </v-text-field>
                </div>
              </div>
              <v-btn color="indigo" class="text-white float-left my-2" @click="updateAds(updatedData.id)">
                <span class="material-icons"></span>
                ثبت
              </v-btn>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <!--      start auth mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="authModal"
              max-width="1200px"
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title>آگهی های من</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="authModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-row class="p-4">
                <v-col v-if="authResult.length > 0" class="col-md-4"
                       v-for="(item,index) in authResult">
                  <v-card
                      :color="mine.find((x)=> x === item.token) != null ? 'red darken-3' : '#191179' "
                      dark
                      class="text-white"
                      max-height="400"
                      elevation="4"
                      :key="item.token"
                  >
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-card-title
                            v-text="item.place"
                            style="font-size: 9pt;font-weight: bold"
                        ></v-card-title>
                        <v-card-subtitle v-text="item.title"></v-card-subtitle>
                        <div class="row px-2">
                          <v-card-subtitle v-text="item.price"></v-card-subtitle>
                          <v-card-subtitle v-text="item.data"></v-card-subtitle>
                        </div>
                      </div>
                      <v-avatar
                          class="ma-3"
                          size="115"
                      >
                        <v-img :src="item.image ? item.image : require('@/assets/img/rblandNotext.webp')"></v-img>
                      </v-avatar>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <!--      start adsList mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="adsModal"
              max-width="1200px"
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title> لیست آگهی های من</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="adsModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <related-ads :Token="adsList"></related-ads>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->


      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <v-card :loading="loading" class="p-3 pt-0">

            <terminal-table class="col-12" :currentPage="datas.current_page"
                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                            :pageCount="datas.last_page"
                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

            <data-table
                v-else
                :data="datas"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :orderBy="tableProps.column"
                :pagination="paginate"
                :orderDir="tableProps.dir"
                :per-page="[10, 25, 50, 100, 500]"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import RelatedAds from "@/view/pages/ladder/relatedAds";
import {debounce} from "../../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "newsList",
  components: {FiltersTable, RelatedAds, TitleRibbon, button, dataTableProps, createTarefe},
  data() {
    return {
      tarafeName: "",
      authModal: false,
      loading: false,
      adsModal: false,
      editModal: false,
      datas: {},
      mine: [],
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      url: `${url}/admin/monitoring/smart/news`,
      selectedNumber: [],
      dataId: '',
      adsList: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام مستعار',
          name: 'nick_name',
          transform(val) {
            return val.data.nick_name != null ? val.data.nick_name : 'وجود ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'کلمه کلیدی',
          name: 'key_word',
          transform: (val) => {
            return val.data.key_word != null ? val.data.key_word : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شهر',
          name: 'city',
          transform: (val) => {
            return this.translator("city_" + val.data.city);
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام دسته',
          primary: true,
          name: 'category',
          transform: (val) => {
            return this.translator(val.data.category);
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'زمان ایجاد',
          name: 'created_at_p',
          transform: (val) => {
            return val.data.created_at_p ? val.data.created_at_p : '-'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'آخرین فعالیت',
          name: 'last_activity',
          transform: (val) => {
            return val.data.last_activity ? val.data.last_activity : '-'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'تعداد ارسال شده',
          name: 'assessed',
          transform: (val) => {
            return val.data.assessed ? val.data.assessed : '0'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          needBtn: true,
          transform: (val) => {
            if (val.data.deleted_at != null)
              return `<span class="badge badge-danger">حذف شده</span>`;
            else {
              let del = () => {

                this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
                  if (value === true) {
                    $.ajax({
                      url: `${url}/smarts/${val.data.id}`,
                      method: 'DELETE',
                      fn: del,
                      headers: {
                        "ACCEPT": "application/json",
                        "Authorization": Token
                      },
                      msg: true,
                      success: (val) => {
                        this.reloadTable();
                      },
                    });
                  }

                }))
              }
              $(document).on('click', `#${val.data.id}`, del);
            }
            return `<button class="btn text-center p-0" id="${val.data.id}" style="font-size:9pt!important"><i class="fa fa-trash-alt text-danger" ></i></button>`;

          },
          orderable: true,
          searchable: true,
        },

      ],
      updatedData: [],
      authResult: [],
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  methods: {
    translator(name) {
      return this.translates[name];
    },
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.datas = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    updateAds: function (id) {
      $.ajax({
        url: `${url}/smarts/${id}`,
        type: 'PUT',
        fn: this.updateAds,
        params: [id],
        data: {
          per: this.updatedData.per,
          count: this.updatedData.count
        },
        headers: {
          'Authorization': Token,
          ACCEPT: 'application/json',
        },
        success: (res) => {
          this.editModal = false;
          this.reloadTable();
        }
      })
    },
    actions(data, type) {
      const vm = this;
      if (type === 'edit') {
        vm.editModal = true;
        $.ajax({
          url: `${url}/smarts/${data.id}`,
          type: 'GET',
          fn: this.actions,
          params: [data, type],
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token
          },
          success: (data) => {
            this.updatedData = data.data
          }
        })


      } else if (type === 'adsList') {
        this.adsModal = true;
        this.adsList = data.id;
        $.ajax({
          url: `${url}/smarts/related/${data.id}/token`,
          type: 'GET',
          fn: this.actions,
          params: [data, type],
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token
          },
          success: (data) => {
            this.mine = data
          }
        })
      } else if (type === 'auth') {
        this.authModal = true;
        $.ajax({
          url: `${url}/divar/search`,
          type: 'POSt',
          fn: this.actions,
          params: [data, type],
          data: data.search_payload,
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token
          },
          success: (data) => {
            this.authResult = data.data
          }
        })
      }
    },
    allowOnlyNumbers(value) {
      if (typeof Number(value.key) !== 'string') {
        let allowedKeys = [8, 46, 38, 40, 37, 39];
        const keypressed = value.which || value.keyCode;
        if (/[^0-9\s]+/.test(value.key)) {
          if (allowedKeys.every(e => e !== keypressed)) {
            value.preventDefault();
          }
        } else return true
      }
    },
    getLocalization() {
      if (localStorage.getItem('localization')) {
        this.translates = JSON.parse(localStorage.getItem('localization'));
        return;
      }
      $.ajax({
        url: `${url}/setting/localization`,
        type: 'GET',
        fn: this.getLocalization,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: (data) => {
          this.translates = data
          localStorage.setItem('localization', JSON.stringify(data));
        }
      })
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url);
    this.getLocalization();
    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });
  },
}
</script>

<style scoped>

</style>


